import { usePushNotifications } from '@hooks/usePushNotifications';
import { useAuth } from '@hooks/useAuth';

/**
 * Renders nothing -- just initializes native push notification listeners
 * when the user is authenticated on a native platform.
 */
export const NativePushInitializer = () => {
  const { isAuthenticated, user } = useAuth();
  // The account is half the registration's dedupe key (#1173): without it, a different
  // account signing in on this device after a session that ended without the sign-out
  // teardown was skipped, and the backend kept the token bound to the previous account.
  usePushNotifications(isAuthenticated, user?.id ?? null);
  return null;
};
